import React, { useEffect, useState } from 'react'
import '../Portfolio/Portfolio.css'
import { Helmet } from 'react-helmet-async'
import { Box, Tab, Tabs } from '@mui/material'

import { useContextData } from '../../core/context/index'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import WalletIcon from '@mui/icons-material/Wallet'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import Toolbar from '@mui/material/Toolbar'
import { ThemeProvider, createTheme } from '@mui/material'
import NavbarOne from '../../Pages/separate/NavbarOne'
// import ActivatedBox from "../Portfolio/Earn/ActivatedBox";
import EarnIndex from '../Portfolio/Earn'
import Geneology from './Geneology/Geneology'
import Payout from './Payout/Payout'
import { toast } from '../../core/lib/toastAlert'
import { useNavigate } from 'react-router-dom'
const drawerWidth = 165
const drawerWidth2 = 200
const theme = createTheme({
  palette: {
    mode: 'dark'
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1260,
      xl: 1536
    }
  }
})
function PremiumDashboard (props) {
  const [tab, setTab] = React.useState(0)
  const { myProfile, profileLoading } = useContextData()
  const navigate = useNavigate()
  const [top, setTop] = useState(80)
  useEffect(() => {
    if (
      !profileLoading &&
      (!myProfile?.gotReferralCount ||
        !myProfile?.gotReferral ||
        myProfile?.gotReferralCount <= 0 ||
        myProfile?.gotReferral?.length <= 0 ||
        (myProfile.additionalKyc.status !== 'manually_approved' &&
          myProfile.additionalBank.status !== 'manually_approved' &&
          myProfile.additionalKyc.status !== 'auto_approved' &&
          myProfile.additionalKyc.status !== 'approved' &&
          myProfile.additionalBank.status !== 'auto_approved' &&
          myProfile.additionalBank.status !== 'approved') ||
        myProfile?.kycOffline?.aadhaar?.status != 1 ||
        myProfile?.kycOffline?.aml?.status != 1 ||
        myProfile?.kycOffline?.identity?.status != 1)
    ) {
      toast({
        type: 'error',
        message: 'You Are Not Eligible for Premium'
      })
      return navigate('/')
    }
  }, [myProfile, profileLoading])
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setTop(0)
      } else {
        setTop(80)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  function a11yProps (index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }
  const handleChangeV3 = (event, newValue) => {
    setTab(() => newValue)
  }
  const data = [
    { id: 0, name: 'Dashboard', icon: <AccountBalanceWalletIcon /> },
    { id: 1, name: 'Genelogy', icon: <AccountTreeIcon /> },
    { id: 2, name: 'Payout', icon: <WalletIcon /> }
  ]
  const drawer = (
    <div>
      <List>
        {data.map((el, index) => {
          return (
            <ListItem
              key={index}
              disablePadding
              sx={{
                background: el?.id == tab ? '#13161D' : '',
                transition: 'all 0.2s ease-in-out'
              }}
            >
              <ListItemButton
                onClick={() => {
                  setTab(el?.id)
                }}
              >
                <ListItemIcon
                  sx={{
                    fontSize: { xs: '0.85rem', lg: '0.9rem' },
                    '&.MuiListItemIcon-root': { minWidth: '40px' }
                  }}
                >
                  {el?.icon}
                </ListItemIcon>
                <ListItemText
                  primary={el?.name}
                  sx={{
                    '&.MuiListItemText-root .MuiTypography-root': {
                      fontSize: { xs: '0.85rem', lg: '0.9rem' }
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
    </div>
  )

  return (
    <div className='bg-default min-vh-100 text-white '>
      <NavbarOne setTheme={props.setTheme} theme={props.theme} />
      <div>
        <section>
          <Helmet>
            <link rel='canonical' href='https://uniticexchange.com/portfolio' />
          </Helmet>

          <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
              <Box
                component='nav'
                sx={{
                  width: { sm: drawerWidth, lg: drawerWidth2 },
                  flexShrink: { sm: 0 }
                }}
                aria-label='mailbox folders'
              >
                <Drawer
                  variant='permanent'
                  sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                      boxSizing: 'border-box',
                      width: { xs: drawerWidth, lg: drawerWidth2 },
                      top: top,
                      zIndex: 1,
                      backgroundColor: 'transparent',
                      transition: 'all 0.2s ease-in-out'
                    }
                  }}
                  open
                >
                  {drawer}
                </Drawer>
              </Box>
              <Box
                component='main'
                sx={{
                  flexGrow: 1,
                  pl: 0,
                  pr: 0,
                  pt: window.innerWidth > 600 ? 1.5 : 1,
                  pb: 0,
                  width: {
                    xs: `calc(100% - ${drawerWidth}px)`,
                    lg: `calc(100% - ${drawerWidth2}px)`
                  },
                  maxHeight: tab !== 5 ? '89vh' : 'auto'
                }}
              >
                <Toolbar
                  sx={{
                    display: { xs: 'block', sm: 'none' },
                    paddingLeft: 0,
                    paddingRight: 0
                  }}
                >
                  <Box className='pt-2'>
                    <Tabs
                      // centered
                      value={tab}
                      onChange={handleChangeV3}
                      variant='scrollable'
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label='scrollable force tabs example'
                      sx={{
                        '& .MuiTabs-indicator': {
                          display: 'none'
                        },
                        '& .MuiTab-root': {
                          color: '#fff',
                          fontSize: '12px',
                          padding: '8px 0px'
                        },
                        '& .MuiTab-root.Mui-selected': {
                          borderBottom: '3px solid #1DAFA1',
                          color: '#fff',
                          fontWeight: 'bold'
                        }
                      }}
                    >
                      <Tab label='Dashboard' {...a11yProps(0)} />
                      <Tab label='Genelogy' {...a11yProps(1)} />
                      <Tab label='Payout' {...a11yProps(2)} />
                    </Tabs>
                  </Box>
                </Toolbar>
                {tab === 0 ? (
                  <>
                    <EarnIndex isPre={true} />
                  </>
                ) : tab === 1 ? (
                  <>
                    <Geneology />
                  </>
                ) : tab === 2 ? (
                  <Payout />
                ) : (
                  <></>
                )}
              </Box>
            </Box>
          </ThemeProvider>
        </section>
      </div>
    </div>
  )
}

export default PremiumDashboard
